/* src/app/builder-screen-beta/inline-editor/inline-editor.component.scss */
.inline-editor-overlay {
  position: fixed;
  z-index: 1100;
  animation: fadeInScale 0.2s ease-out;
  filter: drop-shadow(0 8px 24px rgba(0, 0, 0, 0.15));
}
.inline-editor-card {
  border-radius: 8px;
  border: 2px solid #1890ff;
  background: white;
}
.inline-editor-card :host ::ng-deep .ant-card-head {
  background:
    linear-gradient(
      135deg,
      #e6f7ff 0%,
      #f0f9ff 100%);
  border-bottom: 1px solid #91d5ff;
  padding: 8px 12px;
  min-height: auto;
}
.inline-editor-card :host ::ng-deep .ant-card-head .ant-card-head-title {
  padding: 0;
  font-size: 12px;
  font-weight: 500;
}
.inline-editor-card :host ::ng-deep .ant-card-head .ant-card-extra {
  padding: 0;
}
.inline-editor-card :host ::ng-deep .ant-card-body {
  padding: 12px;
}
.card-title {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #1890ff;
}
.card-title .anticon {
  font-size: 12px;
}
.card-title span {
  font-weight: 500;
}
.card-actions {
  display: flex;
  align-items: center;
  gap: 4px;
}
.quick-properties {
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: 300px;
  overflow-y: auto;
}
.quick-properties::-webkit-scrollbar {
  width: 4px;
}
.quick-properties::-webkit-scrollbar-track {
  background: #f5f5f5;
  border-radius: 2px;
}
.quick-properties::-webkit-scrollbar-thumb {
  background: #d9d9d9;
  border-radius: 2px;
}
.quick-properties::-webkit-scrollbar-thumb:hover {
  background: #bfbfbf;
}
.property-item .property-control {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.property-item .property-control label {
  font-size: 11px;
  font-weight: 500;
  color: #595959;
  margin: 0;
}
.property-item .property-control :host ::ng-deep .ant-input,
.property-item .property-control :host ::ng-deep .ant-input-number,
.property-item .property-control :host ::ng-deep .ant-select-selector {
  border-radius: 4px;
  transition: all 0.2s ease;
}
.property-item .property-control :host ::ng-deep .ant-input:focus,
.property-item .property-control :host ::ng-deep .ant-input:focus-within,
.property-item .property-control :host ::ng-deep .ant-input-number:focus,
.property-item .property-control :host ::ng-deep .ant-input-number:focus-within,
.property-item .property-control :host ::ng-deep .ant-select-selector:focus,
.property-item .property-control :host ::ng-deep .ant-select-selector:focus-within {
  border-color: #1890ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.1);
}
.property-item .property-control :host ::ng-deep .ant-switch.ant-switch-small {
  min-width: 28px;
  height: 16px;
}
.color-input-group {
  display: flex;
  align-items: center;
  gap: 6px;
}
.color-input-group .color-preview {
  width: 20px;
  height: 20px;
  border-radius: 3px;
  border: 1px solid #d9d9d9;
  flex-shrink: 0;
}
.color-input-group :host ::ng-deep .ant-color-picker-trigger {
  width: 24px;
  height: 24px;
  border-radius: 4px;
}
.inline-actions {
  margin-top: 12px;
  padding-top: 8px;
  border-top: 1px solid #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.inline-actions .full-editor-btn {
  padding: 0;
  height: auto;
  font-size: 11px;
}
.inline-actions .full-editor-btn .anticon {
  font-size: 10px;
  margin-right: 4px;
}
.inline-actions .keyboard-hint small {
  color: #8c8c8c;
  font-size: 10px;
  display: flex;
  align-items: center;
  gap: 2px;
}
.inline-actions .keyboard-hint small .anticon {
  font-size: 9px;
}
@keyframes fadeInScale {
  from {
    opacity: 0;
    transform: scale(0.9) translateY(-10px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}
.inline-editor-card {
  transition: all 0.2s ease;
}
.inline-editor-card:hover {
  border-color: #40a9ff;
  filter: drop-shadow(0 12px 32px rgba(0, 0, 0, 0.2));
}
.property-control input:focus,
.property-control .ant-select-focused .ant-select-selector,
.property-control .ant-input-number-focused {
  outline: none;
}
@media (max-width: 768px) {
  .inline-editor-overlay {
    filter: drop-shadow(0 12px 40px rgba(0, 0, 0, 0.25));
  }
  .inline-editor-card {
    border-width: 3px;
  }
  .quick-properties {
    gap: 16px;
  }
  .property-control {
    gap: 6px;
  }
  .property-control label {
    font-size: 12px;
  }
}
@media (prefers-contrast: high) {
  .inline-editor-card {
    border: 3px solid #000;
  }
  .inline-editor-card :host ::ng-deep .ant-card-head {
    background: #f0f0f0;
    border-bottom: 2px solid #000;
  }
  .card-title {
    color: #000;
  }
}
@media (prefers-reduced-motion: reduce) {
  .inline-editor-overlay {
    animation: none;
  }
  .inline-editor-card,
  .property-control input,
  .property-control .ant-input-number,
  .property-control .ant-select-selector {
    transition: none;
  }
}
/*# sourceMappingURL=inline-editor.component.css.map */
